import * as React from 'react';
import { Typography, Variables } from '@SBGSports/referee-react';
import { IconAlertSmall, IconCheckCircleSmall, IconWarningSmall } from '@SBGSports/referee-react/icons';
import styles from '../focus-import.module.css';

type IconType = 'success' | 'warning' | 'error';
interface ValidationMessageProps {
    iconType: IconType;
    message: string;
}

const getIcon = (type: IconType) => {
    switch (type) {
        case 'success':
            return <IconCheckCircleSmall color={Variables.css?.success} />;
        case 'warning':
            return <IconWarningSmall color={Variables.css?.warning} />;
        case 'error':
            return <IconAlertSmall color={Variables.css?.alert} />;
    }
};

export const ValidationMessage: React.FC<ValidationMessageProps> = (props) => {
    const { iconType: type, message } = props;
    return (
        <div className={styles['validation-message-wrapper']}>
            {getIcon(type)}
            <Typography variant="body-2">{message}</Typography>
        </div>
    );
};
